"use strict";
var Stack = (function () {
    function Stack() {
        this._topNode = undefined;
        this._count = 0;
    }
    Stack.prototype.count = function () {
        return this._count;
    };
    Stack.prototype.isEmpty = function () {
        return this._topNode === undefined;
    };
    Stack.prototype.push = function (value) {
        var node = new Node(value, this._topNode);
        this._topNode = node;
        this._count++;
    };
    Stack.prototype.pop = function () {
        var poppedNode = this._topNode;
        this._topNode = poppedNode.previous;
        this._count--;
        return poppedNode.data;
    };
    Stack.prototype.peek = function () {
        return this._topNode.data;
    };
    return Stack;
}());
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = Stack;
var Node = (function () {
    function Node(data, previous) {
        this.previous = previous;
        this.data = data;
    }
    return Node;
}());
